module.exports = __webpack_public_path__ + "img/fondo-footer.9b886bac.png";